<template>
  <div id="inventoryCategory">
    <div class="">
      <van-search
        v-model:value="condition"
        show-action
        placeholder="请输入商品名称"
        @search="toSearch"
        @clear="clear"
      >
        <template #action>
          <div @click="toSearch">搜索</div>
        </template>
      </van-search>
    </div>

    <div class="listWrapper" style="padding-bottom: 50px">
      <div class="leftWrapper">
        <MenuSideBar
          ref="menuSidebar"
          :menuData="categories"
          :activeId="query.categoryId"
          @toggleChildren="clickLeft"
        />
      </div>
      <div class="rightWrapper">
        <GlobalLoading :show="loading || cateLoading" />
        <div v-if="categoriesDetail && categoriesDetail.length">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="已显示全部"
            :immediate-check="false"
            @load="onLoad"
            :offset="50"
            class="productWrapper"
          >
            <div v-for="(cate, index) in categoriesDetail" :key="cate.id">
              <!-- <div class="categoryTitle fs14">{{ cate.name }}</div> -->
              <van-card
                v-for="(item, index) in cate.products"
                :key="(item.id || item.productId) + index"
                :desc="formatDesc(item)"
                :price="formatePrice(item)"
                :title="item.name || item.productName"
                :thumb="
                  item.picture ||
                  'https://fastly.jsdelivr.net/npm/@vant/assets/ipad.jpeg'
                "
              >
                <template #footer>
                  <div class="selectIcon" @click="select(item, $event)">
                    <van-icon
                      name="certificate"
                      size="20"
                      v-if="
                        ordering.some(
                          (t) => t.productId === (item.productId || item.id)
                        )
                      "
                    />
                    <van-icon name="circle" color="#4c9673" size="20" v-else />
                  </div>
                </template>
              </van-card>
            </div>
          </van-list>
        </div>
        <div v-else-if="!loading" class="emptyWrapper">暂无商品</div>
      </div>
    </div>
    <div class="footer">
      <van-button
        round
        block
        type="default"
        plain
        hairline
        @click="handleCancel"
        :disabled="submitting"
        >取消</van-button
      >
      <van-button
        round
        block
        type="primary"
        @click="handleConfirm"
        :loading="submitting"
        :disabled="submitting"
      >
        确认
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { reqWeightCategory } from "../../../service/api/product";
import {
  queryProductList,
  addProduct,
} from "../../../service/api/stock/take";
import GlobalLoading from "@/components/globalLoading";
import { buildTree } from "../../../utils";
import MenuSideBar from "@/components/menuSideBar/index";

export default {
  name: "InventoryCategory",
  data() {
    return {
      categories: [{ id: 0, name: "全部" }],
      categoriesDetail: [],
      currentIndex: 0,
      sheetId: null,
      submitting: false,
      query: {
        name: "",
        pageIndex: 1,
        pageSize: 20,
        available: true,
        categoryId: "",
        planId: "",
      },
      condition: "",
      cateLoading: false,
      loading: false,
      finished: false,
      ordering: [],
    };
  },
  components: {
    GlobalLoading,
    MenuSideBar,
  },
  computed: {
    ...mapState(["shopCart", "userInfo"]),
  },
  created() {
    this.condition = "";
  },
  mounted() {
    this.query.planId = this.$route.query.planId;
    this.sheetId = this.$route.query.sheetId || null;
    this.condition = this.$route.query.name || "";
    this.getRes();
  },
  methods: {
    select(item) {
      const productId = item.productId || item.id;
      const isExist = this.ordering.some((t) => t.productId === productId);
      if (!isExist) {
        this.ordering.push({
          productId,
          productCode: item.productCode,
          productName: item.productName || item.name,
          skuCode: item.skuCode,
          categoryName: item.categoryName,
          categoryId: item.categoryId,
          brandName: item.brandName,
          externalCode: item.externalCode || "",
          retailPrice: item.retailPrice || 0,
          isWeigh: item.isWeigh || 0,
          unit: item.unit || "",
          stockNum: item.stockNum || 0,
        });
      } else {
        this.ordering = this.ordering.filter((t) => t.productId !== productId);
      }
    },
    backToGoods(extraQuery = {}) {
      const { name, ...query } = this.$route.query || {};
      this.$router.push({
        path: "/stock/inventory/goods",
        query: {
          ...query,
          ...extraQuery,
        },
      });
    },
    handleCancel() {
      this.ordering = [];
      this.backToGoods();
    },
    async handleConfirm() {
      if (this.submitting) {
        return;
      }
      if (!this.sheetId) {
        this.$toast("缺少盘点单参数");
        return;
      }
      if (!this.ordering.length) {
        this.backToGoods({ fromCategory: "1" });
        return;
      }

      this.submitting = true;
      this.$toast.loading({
        message: "添加中...",
        forbidClick: true,
        duration: 0,
      });
      try {
        const res = await addProduct({
          sheetId: this.sheetId,
          products: this.ordering.map((item) => ({
            productId: item.productId,
          })),
        });
        this.$toast.clear();
        if (!res || res.code !== 200) {
          this.$nextTick(() => {
            this.$toast((res && res.msg) || "添加失败，请重试");
          });
          return;
        }
        this.$nextTick(() => {
          this.$toast("添加成功");
        });
        this.ordering = [];
        this.backToGoods({ fromCategory: "1" });
      } catch (e) {
        this.$toast.clear();
        const msg =
          (e && e.msg) ||
          (e && e.response && e.response.data && e.response.data.msg) ||
          "添加失败，请重试";
        this.$nextTick(() => {
          this.$toast(msg);
        });
        console.warn("新增盘点单商品失败", e);
      } finally {
        this.submitting = false;
      }
    },
    formatDesc(item) {
      return "商品条码：" + (item.externalCode || "--");
    },
    formatePrice(item) {
      const unit = item.unit ? "/" + item.unit : "";
      const retailPrice = item.retailPrice || 0;
      return String(retailPrice).includes(".")
        ? retailPrice + unit
        : retailPrice + ".00" + unit;
    },
    clear() {
      localStorage.setItem("searchScanText", "");
    },
    toSearch() {
      document.documentElement.scrollTop = 0;
      this.query.pageIndex = 1;
      if (this.$refs?.menuSidebar && this.$refs.menuSidebar.setActiveId) {
        this.$refs.menuSidebar.setActiveId(null);
        this.query.categoryId = "";
      }
      this.search(false);
    },
    onLoad() {
      this.query.pageIndex++;
      this.search(true);
    },
    async search(isLoadMore = false) {
      if (!isLoadMore) {
        this.query.pageIndex = 1;
        this.categoriesDetail = [];
        this.finished = false;
      }
      this.loading = true;

      try {
        this.updateQuery(isLoadMore);

        const rightRes = await queryProductList(this.query);

        if (rightRes.code !== 200) {
          this.loading = false;
          return;
        }

        const categoryMap = new Map([]);
        const data = rightRes.data.datas;
        data.forEach((item) => {
          let categoryId = item.categoryId;
          if (!categoryMap.has(categoryId)) {
            categoryMap.set(categoryId, {
              id: categoryId,
              name: item.categoryName,
              products: [item],
            });
          } else {
            categoryMap.get(categoryId).products.push(item);
          }
        });

        if (isLoadMore) {
          this.categoriesDetail.forEach((cate) => {
            categoryMap.set(cate.id, cate);
          });
          this.categoriesDetail = [
            ...this.categoriesDetail,
            ...Array.from(categoryMap.values()),
          ];
        } else {
          this.categoriesDetail = Array.from(categoryMap.values());
        }

        if (this.query.pageIndex >= rightRes.data.totalPage) {
          this.finished = true;
        }
        this.loading = false;
      } catch (error) {
        if (error.isCanceled) return;
        this.loading = false;
      }
      this.$forceUpdate();
    },

    updateQuery(isLoadMore) {
      if (!isLoadMore) {
        this.query.pageIndex = 1;
      }
      this.query.condition = this.condition;
    },

    async getRes() {
      this.categories = [];
      this.cateLoading = true;
      reqWeightCategory()
        .then(async (res) => {
          if (res.code == 200) {
            const data = res.data;
            this.categories = [{ id: 0, name: "全部" }].concat(buildTree(data));
            if (this.$route.query.categoryId) {
              if (
                this.$refs.menuSidebar &&
                this.$refs.menuSidebar.setActiveId
              ) {
                this.$refs.menuSidebar.setActiveId(
                  this.$route.query.categoryId
                );
              }
              this.clickLeft(this.$route.query.categoryId);
            } else {
              this.search(false);
            }
          }
        })
        .finally(() => {
          this.cateLoading = false;
        });
    },
    async clickLeft(id) {
      document.documentElement.scrollTop = 0;
      this.query.pageIndex = 1;
      this.finished = false;
      if (this.query.categoryId === id) {
        return;
      }
      if (id == 0) {
        this.query.categoryId = "";
      } else {
        this.query.categoryId = id;
      }
      this.search();
    },
  },
};
</script>

<style lang="less" scoped>
#inventoryCategory {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  overflow: hidden;
  padding-top: 46px;
}
.van-card {
  position: relative;
}
.listWrapper {
  display: flex;
  position: absolute;
  top: 93px;
  bottom: 46px;
  width: 100%;
  overflow: hidden;
  height: calc(100vh - 100px);

  .leftWrapper {
    background-color: #f4f4f4;
    height: 100%;
    width: 5.2rem;

    .categoryItem {
      padding: 0.75rem 0;
      border-bottom: solid 1px #e8e9e8;
      position: relative;
    }

    .categoryItem .textWrapper {
      width: 100%;
      display: inline-block;
      line-height: 1.25rem;
      border-left: solid 0.1875rem transparent;
      padding: 0.3125rem 0.6875rem;
      font-size: 0.675rem;
      color: #666666;
    }

    .categoryItem.selected {
      background: #fff;
    }

    .categoryItem.selected .textWrapper {
      border-left-color: #0960bd;
      font-weight: bold;
      font-size: 0.675rem;
      color: #333333;
    }

    @media (min-width: 960px) {
      .wrapper {
        border-right: 1px solid #e8e9e8;
      }

      .wrapper .categoryItem {
        background: #fff;
      }
    }
  }

  .rightWrapper {
    overflow-y: auto;
    height: calc(100% - 46px);
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    position: absolute;
    left: 5.3125rem;
    right: 0;
    bottom: 0;
    top: 0;
    background: #fff;

    .emptyWrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    .categoryTitle {
      padding: 0 0.3125rem;
      height: 1.25rem;
      line-height: 1.25rem;
      font-size: 0.75rem;
      background: #f8f8f8;
      color: #666666;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .selectIcon {
      position: absolute;
      top: 50%;
      left: 0.5rem;
      transform: translateY(-50%);
    }
  }
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  gap: 10px;
  padding: 10px 12px;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  background: rgba(255, 255, 255, 0.96);
  border-top: 1px solid #ebedf0;
  z-index: 100;

  .van-button {
    flex: 1;
    height: 40px;
    font-size: 14px;
    font-weight: 500;
  }
}
#inventoryCategory {
  ::v-deep .van-card__title {
    font-size: 12px;
    max-height: 50px;
    min-height: auto;
    line-height: 20px;
    padding: 0 !important;
    overflow: hidden !important;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  ::v-deep .van-card__content {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly !important;
    min-height: 88px;
  }

  ::v-deep .van-card__content > div:first-child {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    flex: 1;
    min-height: 0;
  }
}

.selectIcon {
  position: absolute;
  top: 50%;
  left: 0.5rem;
  transform: translateY(-50%);
}
</style>
